import dayjs from 'dayjs';

require('dayjs/locale/pl');

const getDateInProperFormat = (activeSite, createdDate) => {
	if (activeSite === 'pl') {
		return dayjs(createdDate).locale('pl').format('D. MM. YYYY');
	}
	if (activeSite === 'de') {
		return dayjs(createdDate).locale('de').format('D. MM. YYYY');
	}
	return dayjs(createdDate).locale('en').format('D. MM. YYYY');
};

export default getDateInProperFormat;
